import { render, staticRenderFns } from "./Difficulty.vue?vue&type=template&id=36cf4021&scoped=true&"
import script from "./Difficulty.vue?vue&type=script&lang=js&"
export * from "./Difficulty.vue?vue&type=script&lang=js&"
import style0 from "./Difficulty.vue?vue&type=style&index=0&id=36cf4021&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36cf4021",
  null
  
)

export default component.exports